import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button, Label, List, Popup } from 'semantic-ui-react';

import { NombrePersonal as NombrePersonalDTO } from 'src/api/protocolo';
import { NombrePersonal } from 'src/componentes';
import { ItemConEtiqueta } from './ItemConEtiqueta';

function colorStringArgba(color: string, opacidad: number) {
    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacidad})`;
}

export interface Props {
    readonly id: number;
    readonly nombre: string;
    readonly sala: string;
    readonly inscritos: number;
    readonly capacidad: number;
    readonly color: string;
    readonly sobrecupo: number;
    readonly profesor?: NombrePersonalDTO;
    readonly asistentes: readonly NombrePersonalDTO[];
    readonly opacarLleno?: boolean;
}

const Curso: React.FunctionComponent<Props> = props => {
    const {
        id,
        capacidad,
        color,
        inscritos,
        nombre,
        sala,
        sobrecupo,
        profesor,
        asistentes,
        opacarLleno = false,
    } = props;

    const cupo = capacidad - inscritos;
    const desvanecer = !cupo && opacarLleno;

    const style: React.CSSProperties = {
        backgroundColor: colorStringArgba(color, desvanecer ? 0.5 : 1),
        width: '8.5em',
        padding: '5px',
        margin: '1px 1px',
        border: '1px solid #444',
        opacity: desvanecer ? 0.7 : 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    };

    return (
        <Popup
            trigger={
                <Link to={`/horarios/cursos/${id}`}>
                    <Button style={style} active size='mini'>
                        <div>{nombre}</div>

                        <div>
                            S:{sala}&nbsp;cupo:&nbsp;{cupo}
                        </div>

                        <div style={{ marginTop: '2px' }}>
                            {profesor ? (
                                <>
                                    {profesor.primerNombre}&nbsp;{profesor.apellidoPaterno[0]}.
                                </>
                            ) : (
                                <>&mdash;</>
                            )}
                        </div>
                    </Button>
                </Link>
            }
            flowing
            closeOnEscape
            hideOnScroll
        >
            <Popup.Header>{nombre}</Popup.Header>
            <Popup.Content>
                <List>
                    <ItemConEtiqueta etiqueta='Sala' valor={sala} />
                    <ItemConEtiqueta
                        etiqueta='Inscritos'
                        valor={inscritos}
                        color={!cupo ? 'red' : undefined}
                    />
                    <ItemConEtiqueta
                        etiqueta='Capacidad'
                        valor={capacidad}
                        color={!cupo ? 'red' : undefined}
                    />
                    <ItemConEtiqueta etiqueta='Sobrecupos' valor={sobrecupo} />
                    {profesor ? (
                        <ItemConEtiqueta
                            etiqueta='Profesor'
                            valor={<NombrePersonal nombre={profesor} patron='%N %P %m.' />}
                        />
                    ) : (
                        <ItemConEtiqueta etiqueta='Profesor' valor='No asignado' color='red' />
                    )}
                    <Asistentes asistentes={asistentes} />
                </List>
            </Popup.Content>
        </Popup>
    );
};

export default Curso;

const Asistentes = (props: { asistentes: readonly NombrePersonalDTO[] }) => {
    const { asistentes } = props;

    if (asistentes.length === 0) {
        return <ItemConEtiqueta etiqueta='Asistentes' valor='No asignados' color='red' />;
    }

    const nombreAsistente = <NombrePersonal nombre={asistentes[0]} patron='%N %P %m.' />;

    if (asistentes.length === 1) {
        return <ItemConEtiqueta etiqueta='Asistentes' valor={nombreAsistente} />;
    }

    return (
        <ItemConEtiqueta
            etiqueta='Asistentes'
            valor={
                <>
                    {nombreAsistente} <Label circular>+ {asistentes.length - 1}</Label>
                </>
            }
        />
    );
};



// WEBPACK FOOTER //
// ./src/modulos/Horarios/componentes/Curso.tsx